import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import type { TGetSocialOrdersQueryParams } from '../api/types/socialOrders'

export function useSocialOrdersQueryArgs() {
  const [searchParams] = useSearchParams()

  const queryArgs = useMemo<TGetSocialOrdersQueryParams>(() => {
    const query = searchParams.get('query')?.trim() ?? ''
    const focus = searchParams.getAll('focus[]').map((v) => v.trim()).filter(Boolean)
    const args: TGetSocialOrdersQueryParams = {}
    if (query) args.query = query
    if (focus.length > 0) args.focus = focus
    return args
  }, [searchParams])

  const resetKey = useMemo(() => JSON.stringify(queryArgs), [queryArgs])

  return { queryArgs, resetKey }
}
